import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { StingrayCommonModule } from '@modules/common/common.module';
import { LoginEnterPIIAnswerComponent } from '@modules/login-shared/components/login-enter-pii-answer/login-enter-pii-answer.component';
import { LoginEnterPIIComponent } from '@modules/login-shared/components/login-enter-pii/login-enter-pii.component';
import { LoginMFACodeComponent } from '@modules/login-shared/components/login-mfa-code/login-mfa-code.component';
import { LoginUserContactMethodsComponent } from '@modules/login-shared/components/login-user-contact-methods/login-user-contact-methods.component';
import { ReCaptchaDirective } from '@modules/login-shared/directives/nb-recaptcha.directive';

@NgModule({
    declarations: [
        LoginMFACodeComponent,
        LoginEnterPIIComponent,
        LoginEnterPIIAnswerComponent,
        LoginUserContactMethodsComponent,
        ReCaptchaDirective
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatSelectModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatRadioModule,
        StingrayCommonModule
    ],
    exports: [
        LoginMFACodeComponent,
        LoginEnterPIIComponent,
        LoginUserContactMethodsComponent,
        ReCaptchaDirective
    ]
})
export class LoginSharedModule {
}
